// DS: CR51
// https://zpl.io/aRzpEyK
import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '../DeviationViews/Dumbo';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './DeviationsMosaic.scss';

const defaultPadding = parseInt(s['padding']);
const thumbSpacing = parseInt(s['thumb-spacing']);
const mobileThumbSpacing = parseInt(s['mobile-thumb-spacing']);

export interface Props {
  className?: string;
  contentClassName?: string;
  deviations: PapiDeviation[];
  width: number;
  height: number;
  padding?: number;
  deviationView?: React.ComponentType<any>;
}

export const DeviationsMosaic: React.FC<Props> = ({
  width,
  height,
  className,
  contentClassName,
  deviations,
  padding,
  deviationView: DeviationView = DeviationDumbView,
}) => {
  const isMobile = useContext(MobileContext);

  if (!deviations.length) {
    return <div style={{ width, height }} className={className} />;
  }

  if (deviations.length === 1) {
    return (
      <DeviationView deviation={deviations[0]} width={width} height={height} />
    );
  }

  const effectivePadding = padding !== undefined ? padding : defaultPadding;
  const effectiveThumbSpacing = isMobile ? mobileThumbSpacing : thumbSpacing;

  const fullWidth = width - effectivePadding * 2;
  const fullHeight = height - effectivePadding * 2;
  const halfWidth = Math.floor((fullWidth - effectiveThumbSpacing) / 2);
  const halfHeight = Math.floor((fullHeight - effectiveThumbSpacing) / 2);

  let rightHalf;

  if (deviations.length > 2) {
    rightHalf = (
      <div className={s['vertical-tile']}>
        <div className={s['horizontal-tile']}>
          <DeviationView
            deviation={deviations[1]}
            width={halfWidth}
            height={halfHeight}
          />
        </div>
        <div className={s['horizontal-tile']}>
          <DeviationView
            deviation={deviations[2]}
            width={halfWidth}
            height={halfHeight}
          />
        </div>
      </div>
    );
  } else {
    rightHalf = (
      <div className={s['vertical-tile']}>
        <DeviationView
          deviation={deviations[1]}
          width={halfWidth}
          height={fullHeight}
        />
      </div>
    );
  }

  return (
    <div
      className={classnames(s['content'], className)}
      style={{ width, height }}
    >
      <div className={classnames(s['tiles'], contentClassName)}>
        <div className={s['vertical-tile']}>
          <DeviationView
            deviation={deviations[0]}
            width={halfWidth}
            height={fullHeight}
          />
        </div>
        {rightHalf}
      </div>
    </div>
  );
};

export default DeviationsMosaic;
